/**
 @description: description
 @date: 2021-08-22
 @author: pro(puluotech@gmail.com)
 */

let sever_env = 'beta' //本地开发时，指定对应的接口环境

if (process.env.NODE_ENV !== 'development' && process.env.CODE_ENV) {
    // sls  deploy 用
    //config/env.js  getClientEnvironment 方法内注入的，npm run sls会从 /.env 文件中读取
    sever_env = process.env.CODE_ENV
}

export const packageInfo={
    version: '1.0.0',
    env: sever_env,
    build: '1569811415972',
}

console.log('packageInfo:', packageInfo)

export const IS_BETA = packageInfo.env === 'beta'
export const IS_REL = packageInfo.env === 'release'
export const IS_PRODUCTION = packageInfo.env === 'production'
